import { ReactNode } from 'react';
import { SelectOption } from 'global';
import { capitalizeFirstLetter } from 'formatters';
import { Mail, Work, AttachMoney, LocalShipping, ShowChart } from '@mui/icons-material';

export const TRNSACT_DASHBOARD_TYPE = 'TRNSACT';

export const OPTION_LIST_ICON_MAPPER: Record<string, ReactNode> = {
  mail: <Mail color="primary" />,
  work: <Work color="primary" />,
  showChart: <ShowChart color="primary" />,
  localShipping: <LocalShipping color="primary" />,
  attachMoney: <AttachMoney color="primary" />,
};

export const SELECT_OPTION_INTEGRATION_TYPE: SelectOption[] = [
  { label: 'Trevor', value: 'TREVOR' },
  { label: 'Metabase', value: 'METABASE' },
];

export const SELECT_OPTION_DASHBOARD_ICON: SelectOption[] = Object.keys(OPTION_LIST_ICON_MAPPER).map(iconKey => ({
  label: capitalizeFirstLetter(iconKey),
  value: iconKey,
}));
